<template>
  <div class="detailInfo w">
  <div class="center_all detailInfo_content" v-if="detailObj">
    <div ref="bkxx">
      <el-button class="SwitchingVersions" v-if="isSci" @click="switchVersion"
        >切换版本</el-button
      >
      <ZhDetails
        @scrollToTarget="scrollToTarget"
        :details="detailObj"
        :isZh="!isSci ? Boolean(detailObj.cn) : showZh"
      ></ZhDetails>
      <!-- <EnDetails
        @scrollToTarget="scrollToTarget"
        :details="detailObj"
        v-else
      ></EnDetails> -->
    </div>
    <div class="center_1">
      <!-- 期刊概况 -->
      <div class="dictionary_box">
        <!-- <h2 class="center_title">期刊概况</h2> -->
        <el-radio-group
          class="dictionary_radio"
          v-model="dictionaryTimeValue"
          @change="handleDictionaryTimeChange"
        >
          <el-radio-button v-for="item in dictionaryTimeOptions" :key="item.key" :label="item.key">{{ item.value }}</el-radio-button>
        </el-radio-group>
        <div class="conter_1">
          <div
            v-for="(item, index) in dictionary"
            :key="index"
            :class="
              item.number || item.number === 0 ? 'con_01 cuser01' : 'con_01'
            "
            @click="goRoute(item)"
          >
            <NumRoll
              v-if="item.number || item.number === 0"
              :numbers="item.number + ''"
              :colors="colors[index]"
            />
            <div class="con_01_title">{{ item.title }}</div>
          </div>
        </div>
      </div>
      <!-- 影响因子 -->
      <!-- <div>
        <h2 class="center_title">
          影响因子
          <div class="fr btn">
            <el-button
              type="text"
              icon="el-icon-xz"
              @click="
                () => {
                  handleDownload('influence');
                }
              "
              >下载</el-button
            >
          </div>
        </h2>
        <SimpleTable
          :tableData="influenceTableData"
          :columnData="influenceColumn"
          @onChangeSort="
            (prop, order) => {
              handleChangeSort(prop, order, 'influence');
            }
          "
          :initObj="influencePageObj"
          @onChangePageData="
            pageObj => {
              getInfluenceData(pageObj);
            }
          "
          @onClickTitle="
            item => {
              handleClusterDetail(item, 'influence');
            }
          "
        />
      </div> -->
        <!--统计评价  -->
      <div ref="tjpj">
        <ZhStatic v-if="!isSci ? detailObj.cn : showZh"></ZhStatic>
      </div>
      <div v-if="!isSci ? !detailObj.cn : !showZh">
        <!-- 统计数据 -->
        <div class="detailInfo_title" ref="tj">
          <el-divider>统计数据</el-divider>
        </div>
        <!-- CiteScore -->
        <div ref="citeScore" class="mb-20">
          <CiteScore />
        </div>
        <!-- JCR -->
        <div ref="jcr" class="mb-20">
          <JcrCom />
        </div>
        <!-- 中科院分区 -->
        <div ref="zkyfq" class="mb-20">
          <ZkyCom :journalAlert="detailObj.journalAlert" />
        </div>
      </div>
      <!--  -->
      <!--统计评价  -->
      <div ref="tjpjen">
        <div >
          <h2 class="center_title">{{ detailObj.name }} 影响因子与历年 IF</h2>
          <SimpleTable
            :tableData="isSci&&!showZh ? influencingTableData : influencingTableDataZh"
            :columnData="isSci&&!showZh ? influencingColumn : influencingColumnZh"
            :initObj="influencePageObj"
            :hidePagination="true"
          />
          <p v-if="!showMore">
            <span class="editLink" @click="influencingMore">More</span>
          </p>
        </div>
      </div>
      <!-- 年度被引报告 -->
      <div ref="citeEveryYear">
        <div>
          <h2 class="center_title">{{ detailObj.name }} 年度被引报告</h2>
          <!-- 年份选择器 -->
          <div class="cite-every-year-selector">
            <span
              v-for="year in pastElevenYears"
              :key="year"
              :class="['cite-every-year-option', { active: (pendingSelectedYear !== null ? pendingSelectedYear : selectedYear) === year }]"
              @click="handleYearSelect(year)"
            >
              {{ year }}
            </span>
          </div>
          <!-- 表格 -->
          <div class="ceyt">
            <div
              v-for="(row, rowIndex) in citeEveryYearTableRows"
              :key="rowIndex"
              class="ceyt-row"
            >
              <div class="ceyt-cell ceyt-cell-label">
                {{ row.metricName }}
              </div>
              <div
                v-for="year in currentYearRange"
                :key="year"
                :class="['ceyt-cell', 'ceyt-cell-data', { 'ceyt-cell-year': rowIndex === 0 }]"
              >
                {{ row[`year_${year}`] }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 引证统计 -->
      <div class="detailInfo_title" ref="yzyy">
        <el-divider>引用引证发文数据</el-divider>
      </div>
      <!-- 引用统计  -->
      <div>
        <h2 class="center_title">
          引用期刊引用量统计
          <div class="fr btn">
            <el-radio-group v-model="quoteTimeValue">
              <el-radio-button
                v-for="item in timeOptions"
                :key="item.key"
                :label="item.key"
                >{{ item.value }}</el-radio-button
              >
            </el-radio-group>
            <el-button
              type="text"
              icon="el-icon-xz"
              @click="
                () => {
                  handleDownload('quote');
                }
              "
              >下载</el-button
            >
          </div>
        </h2>
        <SimpleTable
          ref="quoteTable"
          :tableData="quoteTableData"
          :columnData="quoteTimeValue === 3 ? quoteColumnThree : quoteColumn"
          :initObj="quotePageObj"
          @onChangeSort="
            (prop, order) => {
              handleChangeSort(prop, order, 'quote');
            }
          "
          @onChangePageData="
            pageObj => {
              getReferenceData(pageObj);
            }
          "
        />
      </div>
      <div>
        <h2 class="center_title">
          引证期刊引证量统计
          <div class="fr btn">
            <el-radio-group v-model="citationTimeValue">
              <el-radio-button
                v-for="item in timeOptions"
                :key="item.key"
                :label="item.key"
                >{{ item.value }}</el-radio-button
              >
            </el-radio-group>
            <el-button
              type="text"
              icon="el-icon-xz"
              @click="
                () => {
                  handleDownload('citation');
                }
              "
              >下载</el-button
            >
          </div>
        </h2>
        <SimpleTable
          ref="citationTable"
          :tableData="citationTableData"
          :columnData="
            citationTimeValue === 3 ? citationColumnThree : citationColumn
          "
          :initObj="citationPageObj"
          @onChangeSort="
            (prop, order) => {
              handleChangeSort(prop, order, 'citation');
            }
          "
          @onChangePageData="
            pageObj => {
              getCitationData(pageObj);
            }
          "
        />
      </div>
      <!-- 机构发文统计-->
      <div id="magInstitutionCount">
        <h2 class="center_title">
          机构发文量统计
          <div class="fr btn">
            <el-select
              v-model="institutionTypeValue"
              placeholder="请选择"
              style="width:100px;top:-4px;"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <el-radio-group v-model="institutionTimeValue">
              <el-radio-button
                v-for="item in timeOptions"
                :key="item.key"
                :label="item.key"
                >{{ item.value }}</el-radio-button
              >
            </el-radio-group>
            <el-button
              type="text"
              icon="el-icon-xz"
              @click="
                () => {
                  handleDownload('institution');
                }
              "
              >下载</el-button
            >
          </div>
        </h2>
        <SimpleTable
          ref="institutionTable"
          :tableData="institutionTableData"
          :columnData="
            institutionTimeValue === 3
              ? institutionColumnThree
              : institutionColumn
          "
          :initObj="institutionPageObj"
          @onChangeSort="
            (prop, order) => {
              handleChangeSort(prop, order, 'institution');
            }
          "
          @onChangePageData="
            pageObj => {
              getInstitutionData(pageObj);
            }
          "
        />
      </div>
      <!-- 机构列表统计 -->
      <div id="magArticleCount">
        <h2 class="center_title">
          机构引证量统计
          <div class="fr btn">
            <el-radio-group v-model="articleTimeValue">
              <el-radio-button
                v-for="item in timeOptions"
                :key="item.key"
                :label="item.key"
                >{{ item.value }}</el-radio-button
              >
            </el-radio-group>
            <el-button
              type="text"
              icon="el-icon-xz"
              @click="
                () => {
                  handleDownload('institutionCitation');
                }
              "
              >下载</el-button
            >
          </div>
        </h2>
        <SimpleTable
          ref="articleTable"
          :tableData="citationInstitutionTableData"
          :columnData="
            articleTimeValue === 3 ? articleColumnThree : yzArticleColumn
          "
          :initObj="citationInstitutionPageObj"
          @onChangeSort="
            (prop, order) => {
              handleChangeSort(prop, order, 'citationInstitution');
            }
          "
          @onChangePageData="
            pageObj => {
              citationInstitution(pageObj);
            }
          "
        />
      </div>
      <!-- 论文引证统计 -->
      <div id="magArticleCount">
        <h2 class="center_title">
          论文被引详情统计
          <div class="fr btn">
            <el-select
              v-model="articleTypeValue"
              placeholder="请选择"
              style="width:100px;top:-4px;"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <el-radio-group v-model="articleDetailTimeValue">
              <el-radio-button v-for="item in timeOptions" :key="item.key" :label="item.key">{{ item.value }}</el-radio-button>
            </el-radio-group>
            <el-button
              type="text"
              icon="el-icon-xz"
              @click="
                () => {
                  handleDownload('article');
                }
              "
              >下载</el-button
            >
          </div>
        </h2>
        <SimpleTable
          ref="articleTable"
          :tableData="articleTableData"
          :columnData="articleColumn"
          :initObj="articlePageObj"
          @onChangeSort="
            (prop, order) => {
              handleChangeSort(prop, order, 'article');
            }
          "
          @onChangePageData="
            pageObj => {
              getArticleData(pageObj);
            }
          "
          @onClickTitle="handleJumpUrl"
        />
      </div>
    </div>
    <!--  -->
  </div>
  </div>
</template>
<script>
import { baseUrl } from "@/assets/js/base64";
import { mapGetters } from "vuex";
import NumRoll from "@/components/NumRoll";
import SimpleTable from "@/components/SimpleTable";
import ZhDetails from "./components/ZhDetails.vue";
import EnDetails from "./components/EnDetails.vue";
import ZhStatic from "./components/ZhStatic.vue";
import CiteScore from "./components/CiteScore.vue";
import JcrCom from "./components/JcrCom.vue";
import ZkyCom from "./components/ZkyCom.vue";
import {
  GetInfluence,
  GetReference,
  GetCitationV2,
  exportCitation,
  exportReference,
  GetCitationGraph,
  GetQuoteGraph,
  GetAllCitationQuote,
  GetMagByName,
  GetInstitution,
  GetArticle,
  exportInstitution,
  exportInstitutionCitation,
  exportArticle,
  exportInfluence,
  CitationInstitutionV2,
  Getifoid,
  GetciteEveryYear
} from "@/api/analysis";
import {
  GetMagDetail,
  GetMagOverView,
  GetincludedDatabase,
  GetMagInfo
} from "@/api/detail";
import { formatNum } from "@/utils";
export default {
  components: {
    NumRoll,
    SimpleTable,
    ZhDetails,
    ZhStatic,
    EnDetails,
    CiteScore,
    JcrCom,
    ZkyCom
  },
  computed: {
    ...mapGetters({
      magId: "magId"
    }),
    isSci() {
      return (
        this.detailObj &&
        this.detailObj.cn &&
        Array.isArray(this.includedData) &&
        this.includedData.some(item => item.abbrName === "SCI")
      );
    },
    // 当前选中年份对应的年份范围（用于表格列）
    currentYearRange() {
      return this.getYearRange(this.selectedYear);
    },
    // 年度被引报告表格行数据（转置结构）
    citeEveryYearTableRows() {
      const yearRange = this.currentYearRange;

      // 如果没有数据，返回默认结构
      if (!this.citeEveryYearTableData || this.citeEveryYearTableData.length === 0) {
        return this.getDefaultTableRows();
      }

      const dataMap = {};
      this.citeEveryYearTableData.forEach(item => {
        dataMap[item.articleYear] = item;
      });

      // 构建转置后的表格数据
      const rows = [];

      // 第一行：本刊文章见刊的年份
      const yearRow = { metricName: '本刊文章见刊的年份' };
      yearRange.forEach(year => {
        yearRow[`year_${year}`] = year;
      });
      rows.push(yearRow);

      // 第二行：在选定年份的被引次数
      const totalCitesRow = { metricName: `在${this.selectedYear}年的被引次数` };
      yearRange.forEach(year => {
        const item = dataMap[year];
        totalCitesRow[`year_${year}`] = item ? item.totalCites : '--';
      });
      rows.push(totalCitesRow);

      // 第三行：被本刊自己引用的次数
      const selfCitesRow = { metricName: '被本刊自己引用的次数' };
      yearRange.forEach(year => {
        const item = dataMap[year];
        selfCitesRow[`year_${year}`] = item ? item.selfCites : '--';
      });
      rows.push(selfCitesRow);
      return rows;
    }
  },
  data() {
    return {
      articleTimeValue: 5, // 当前 引证机构列表统计 时间筛选 选中项
      getMagId: "", // 传过来时选择的magId
      chooseId: "", // 从上个页面传过来的
      detailObj: null, // 详情对象
      dictionary: [
        { key: "articleTotalCount", title: "总发文量" },
        { key: "referenceTotalCount", title: "总被引量" },
        { key: "referenceAverageCount", title: "平均被引量" },
        { key: "referenceSingleMax", title: "单篇最高被引量" }
      ],
      // 期刊概况时间筛选（topYear），默认全部 -1
      dictionaryTimeValue: -1,
       // 近几年选项的options
       dictionaryTimeOptions: [
        {
            key: -1,
            value: '全部'
        },
        {
            key: 10,
            value: '近10年'
        },
        {
          key: 5,
          value: '近5年'
        },
        {
          key: 3,
          value: '近3年'
        }
      ],
      colors: ["#ec5463", "#eea806", "#6eb91a", "#2db897"], // 期刊领域概况 颜色
      // 引证图谱
      chooseYearRange: 5,
      rankOptions: [
        {
          value: "5",
          label: "5"
        },
        {
          value: "10",
          label: "10"
        }
      ],
      // 近几年选项的options
      timeOptions: [
        {
          key: 5,
          value: "近5年"
        },
        {
          key: 3,
          value: "近3年"
        }
      ],
      yearOptions: [
        {
          value: "count1",
          label: "2020"
        },
        {
          value: "count2",
          label: "2019"
        },
        {
          value: "count3",
          label: "2018"
        },
        {
          value: "count4",
          label: "2017"
        },
        {
          value: "count5",
          label: "2016"
        }
      ],
      chooseYearVal: "count1",
      citationTableData: [],
      citationVal: "5",
      citationPageObj: {
        page: 1,
        size: 10,
        sort: "totalCount5,desc"
      }, // 引证统计分页
      citationTimeValue: 5, // 当前 引证统计 时间 选中项
      citationColumn: [
        {
          title: "引证刊名",
          prop: "ctiMagName",
          width: "300px",
          notSortable: true,
          align: 'left'
        },
        ...recentFiveYear,
        {
          title: "合计",
          prop: "totalCount5"
        }
      ], // 引证统计 表格header 内容（近五年）
      citationColumnThree: [
        {
          title: "引证刊名",
          prop: "ctiMagName",
          width: "300px",
          notSortable: true,
          align: 'left'
        },
        ...recentThreeYear,
        {
          title: "合计",
          prop: "totalCount3"
        }
      ], // 引证统计 表格header 内容（近三年）
      // 被引统计
      quoteTimeValue: 5, // 当前 引用统计 时间 选中项
      quoteTableData: [],
      quoteVal: "5",
      quotePageObj: {
        page: 1,
        size: 10,
        sort: "totalCount5,desc"
      },
      quoteColumnThree: [
        {
          title: "引用刊名",
          prop: "refMagName",
          width: "300px",
          notSortable: true,
          align: 'left'
        },
        ...recentThreeYear,
        {
          title: "合计",
          prop: "totalCount3"
        }
      ], // 引用统计 表格header 内容(近三年)
      quoteColumn: [
        {
          title: "引用刊名",
          prop: "refMagName",
          width: "300px",
          notSortable: true,
          align: 'left'
        },
        ...recentFiveYear,
        {
          title: "合计",
          prop: "totalCount5"
        }
      ], // 引用统计 表格header 内容(近五年)
      chooseDataKey: "totalCount5",
      // 发文机构统计
      institutionTimeValue: 5, // 当前 发文机构统计 时间筛选 选中项
      institutionPageObj: {
        page: 1,
        size: 10,
        sort: "totalCount5,desc"
      },
      institutionTableData: [],
      institutionColumn: [
        {
          title: "发文机构",
          prop: "institutionName",
          width: "190px",
          notSortable: true,
          align: 'left'
        },
        ...recentFiveYear,
        {
          title: "发文合计",
          prop: "totalCount5",
          width: "110px",
        },
        {
          title: "被引合计",
          width: "110px",
          prop: "referedCount5V2"
        },
        {
          title: "平均被引",
          prop: "ratioCount5",
          notSortable: true
        },
        {
          title: "单篇最高被引",
          width: "130px",
          prop: "singleReferedCount5V2"
        }
      ], // 发文机构统计 表格header 内容（近五年）
      institutionColumnThree: [
        {
          title: "发文机构",
          prop: "institutionName",
          width: "300px",
          notSortable: true,
          align: 'left'
        },
        ...recentThreeYear,
        {
          title: "发文合计",
          prop: "totalCount3"
        },
        {
          title: "被引合计",
          prop: "referedCount3V2"
        },
        {
          title: "平均被引",
          prop: "ratioCount3",
          notSortable: true
        },
        {
          title: "单篇最高被引",
          width: "150px",
          prop: "singleReferedCount3V2"
        }
      ], // 发文机构统计 表格header 内容（近三年）
      // 发文统计和引证统计的option选项
      options: [
        {
          value: "mag",
          label: "本刊"
        },
        {
          value: "domain",
          label: "本领域"
        }
      ],
      institutionTypeValue: "mag",
      // 论文引证统计
      articlePageObj: {
        page: 1,
        size: 10
      },
      // 论文被引详情统计的独立排序对象
      articleDetailPageObj: {
        page: 1,
        size: 10,
        sort: ""  // 论文被引详情统计默认不排序
      },
      articleTableData: [],
      radio5: "近3年", // 当前 论文引证统计 选中项
      articleColumn: [
        {
          title: "论文标题",
          prop: "articleName",
          special: true,
          width: "300px",
          notSortable: true,
          align: 'left'
        },
        {
          title: "刊物名称",
          prop: "magName",
          notSortable: true
        },
        {
          title: "关键词",
          prop: "keywords",
          notSortable: true
        },
        {
          title: "作者",
          prop: "author",
          notSortable: true
        },
        {
          title: "机构",
          prop: "institution",
          notSortable: true
        },
        {
          title: "年份",
          prop: "year"
        },
        {
          title: "刊期",
          prop: "issue",
          notSortable: true
        },
        {
          title: "引证次数",
          prop: "totalCount"
        }
      ], // 论文引证统计 表格header 内容
      articleTypeValue: "mag",
      includedDatabasesArr: [],
      // 影响因子
      influenceTableData: [],
      influencePageObj: {
        page: 1,
        size: 10,
        sort: ""
      },
      influenceColumn: [
        {
          title: "刊物名称",
          prop: "name",
          special: true,
          width: "300px",
          notSortable: true
        },
        {
          title: "知网",
          prop: "influence1"
        },
        {
          title: "万方",
          prop: "influence2"
        },
        {
          title: "百度学术",
          prop: "influence3"
        }
      ],
      citationInstitutionTableData: [],
      citationInstitutionPageObj: {
        page: 1,
        size: 10,
      }, // 引证机构列表统计 分页参数
      yzArticleColumn: [
        {
          title: "引证机构",
          prop: "institutionName",
          special: true,
          width: "190px",
          notSortable: true,
          align: 'left'
        },
        ...recentFiveYear,
        {
          title: "合计",
          prop: "totalCount5"
        }
      ], // 引证机构列表统计 表格header 内容（近五年）
      articleColumnThree: [
        {
          title: "机构",
          prop: "institutionName",
          special: true,
          width: "300px",
          notSortable: true,
          align: 'left'
        },
        ...recentThreeYear,
        {
          title: "合计",
          prop: "totalCount3"
        }
      ], // 引证机构列表统计 表格header 内容（近三年）
      influencingTableData: [],
      influencingTableDataZh: [],
      influencingColumn: [
        {
          title: "年度",
          prop: "year",
          notSortable: true
        },
        {
          title: "文章数/年",
          prop: "articleCount",
          notSortable: true
        },
        {
          title: "5年平均分",
          prop: "fiveYearAverageScore",
          notSortable: true
        },
        {
          title: "自引率%",
          prop: "selfCitationRate",
          notSortable: true
        },
        {
          title: "IF",
          prop: "ifoid",
          notSortable: true
        }
      ],
      influencingColumnZh: [
        {
          title: "年度",
          prop: "year",
          notSortable: true
        },
        {
          title: "IF",
          prop: "ifoid",
          notSortable: true
        }
      ],
      showMore: true,
      includedData: [],
      showZh: true,
      articleDetailTimeValue: 5,
      pastElevenYears: [],
      selectedYear: new Date().getFullYear(), // 默认当前年份
      pendingSelectedYear: null, // 临时选中的年份（用于高亮显示，等接口返回后再更新 selectedYear）
      citeEveryYearTableData: [], // 原始数据
    };
  },
  watch: {
    magId(nv) {
      if (this.getMagId !== nv) {
        this.$router.push("/analysis");
      }
      // magId 变化时重新获取年度被引报告数据
      if (nv) {
        this.getCiteEveryYearData();
      }
    },
    articleTypeValue() {
      this.getArticleData();
      this.$refs.articleTable.clearSort();
    },
    institutionTypeValue() {
      this.getInstitutionData();
      this.$refs.institutionTable.clearSort();
    },
    institutionTimeValue(nv) {
      this.institutionPageObj.sort =
        nv === 3 ? "totalCount3,desc" : "totalCount5,desc";
      this.getInstitutionData();
      this.$refs.institutionTable.clearSort();
    },
    citationTimeValue(nv) {
      this.citationPageObj.sort =
        nv === 3 ? "totalCount3,desc" : "totalCount5,desc";
      this.getCitationData();
      this.$refs.citationTable.clearSort();
    },
    quoteTimeValue(nv) {
      this.quotePageObj.sort =
        nv === 3 ? "totalCount3,desc" : "totalCount5,desc";
      this.getReferenceData();
      this.$refs.quoteTable.clearSort();
    },
    articleDetailTimeValue(nv) {
      this.articleDetailPageObj.top =
        nv === 3 ? 3 : 5;
      this.getArticleData();
      this.$refs.articleTable.clearSort();
    },
    citationVal() {
      this.echart();
    },
    quoteVal() {
      this.echart();
    },
    chooseYearVal(nv) {
      this.chooseDataKey = nv;
      // 选择的时间之后，将三五年清除选中
      this.chooseYearRange = 0;
      const citationPromise = this.getCitationGraphData();
      const quotePromise = this.getQuoteGraphData();
      Promise.all([citationPromise, quotePromise]).then(([res1, res2]) => {
        if (res1 && res2) {
          // 更新echarts图
          this.echart();
        }
      });
    },
    chooseYearRange(nv) {
      if (nv === 3) {
        this.chooseDataKey = "totalCount3";
      } else if (nv === 5) {
        this.chooseDataKey = "totalCount5";
      }
      if (nv !== 0) {
        const citationPromise = this.getCitationGraphData();
        const quotePromise = this.getQuoteGraphData();
        Promise.all([citationPromise, quotePromise]).then(([res1, res2]) => {
          if (res1 && res2) {
            // 更新echarts图
            this.echart();
          }
        });
      }
    },
    chooseId() {
      // this.getMagDetail();
      this.getMagInfo()
      this.getMagOverView();
      this.getCitationData();
      this.getReferenceData();
      const citationPromise = this.getCitationGraphData();
      const quotePromise = this.getQuoteGraphData();
      const totalPromise = this.getCitationQuoteData();
      Promise.all([citationPromise, quotePromise, totalPromise]).then(
        ([res1, res2, res3]) => {
          if (res1 && res2 && res3) {
            // 更新echarts图
            this.echart();
          }
        }
      );
    },
    articleTimeValue(nv) {
      this.articlePageObj.sort =
        nv === 3 ? "totalCount3,desc" : "totalCount5,desc";
      this.citationInstitution();
      this.$refs.articleTable.clearSort();
    }
  },
  mounted() {
    this.chooseId = this.$route.query.searchId;
    this.getMagId = this.$route.query.searchId;
    this.getPastElevenYears()
    this.getMagInfo()
    // 初始化年度被引报告数据
    this.getCiteEveryYearData()
    // this.getMagDetail();
    this.getMagOverView();
    this.getCitationData();
    this.getReferenceData();
    this.getInstitutionData();
    this.getArticleData();
    this.getInfluenceData();
    this.citationInstitution();
    this.Getifoid();
    this.GetifoidZh();
    this.getincludedDatabase();
    const citationPromise = this.getCitationGraphData();
    const quotePromise = this.getQuoteGraphData();
    const totalPromise = this.getCitationQuoteData();
    Promise.all([citationPromise, quotePromise, totalPromise]).then(
      ([res1, res2, res3]) => {
        if (res1 && res2 && res3) {
          // 更新echarts图
          this.echart();
        }
      }
    );
  },
  methods: {
    getYearRange(selectedYear) {
      const years = [];
      for (let i = 0; i < 11; i++) {
        years.push(selectedYear - i);
      }
      return years;
    },
    // 规范 topYear 值，非法输入回退为 -1（全部）
    normalizeTopYear(val) {
      const allowList = [-1, 3, 5, 10]
      const numVal = Number(val)
      return allowList.includes(numVal) ? numVal : -1
    },
    // 期刊概况时间筛选变化时触发
    handleDictionaryTimeChange(val) {
      const topYear = this.normalizeTopYear(val)
      // 若选择值被矫正，保持 v-model 同步
      if (topYear !== this.dictionaryTimeValue) {
        this.dictionaryTimeValue = topYear;
      }
      // chooseId 未就绪则跳过，避免无效请求
      if (!this.chooseId) return;
      this.getMagOverView(topYear);
    },
    getMagInfo() {
      const params = {
        magId: this.magId
      };
      GetMagInfo(params).then(res => {
        if (res && res.data && res.data.status === 0) {
          const { data } = res.data;
          let noKeys = ["cn"];
          for (let key in data) {
            if (!noKeys.includes(key)) {
              data[key] =
                data[key] === "" ||
                data[key] === null ||
                data[key] === undefined
                  ? "--"
                  : data[key];
            }
          }
          // this.includedDatabasesArr = data.includedDatabases ? JSON.parse(data.includedDatabases) : []
          this.$set(this, "detailObj", data);
        } else {
          const { message } = res.data;
          this.$message.error(message);
        }
      })
    },
    // 期刊收录：
    getincludedDatabase() {
      const params = {
        magId: this.magId
      };
      GetincludedDatabase(params).then(res => {
        if (res && res.data && res.data.status === 0) {
          this.includedData = res.data.data;
        }
      });
    },
    influencingMore() {
      this.showMore = !this.showMore;
      if (this.isSci&&!this.showZh) {
        this.GetifoidZh();
      } else {
        this.Getifoid();
      }
    },
    GetifoidZh() {
      const params = {
        magId: this.magId,
        size: this.showMore ? 999 : 5,
        page: 0,
        siteCode:"WANFANG"
      };
      Getifoid(params).then(res => {
        if (res && res.data && res.data.status === 0) {
          this.influencingTableDataZh = res.data.data.content;
        }
      });
    },
    Getifoid() {
      const params = {
        magId: this.magId,
        size: this.showMore ? 999 : 5,
        page: 0,
      };
      Getifoid(params).then(res => {
        if (res && res.data && res.data.status === 0) {
          this.influencingTableData = res.data.data.content;
        }
      });
    },
    switchVersion() {
      this.showZh = !this.showZh;
    },
    // 点击按钮滚动到目标位置
    scrollToTarget(refName) {
      const targetElement = this.$refs[refName];
      if (targetElement) {
        targetElement.scrollIntoView(); // 平滑滚动
      }
    },
    // 引证机构列表统计数据请求
    citationInstitution (pageParams = {}) {
      const { page = 1, size = 10 } = pageParams;
      const params = {
        magId: this.magId,
        page: page - 1,
        size,
        sort: this.citationInstitutionPageObj.sort
      };
      CitationInstitutionV2(params).then(res => {
        if (res && res.data && res.data.status === 0) {
          const { data } = res.data;
          const { content = [], totalElements = 0 } = data;
          this.citationInstitutionPageObj = {
            ...this.citationInstitutionPageObj,
            page,
            size,
            total: totalElements
          };
          this.citationInstitutionTableData = content;
        } else {
          const { message } = res.data;
          this.$message.error(message);
        }
      });
    },
    // 获取影响因子数据
    getInfluenceData(pageParams = {}) {
      const { page = 1, size = 10 } = pageParams;
      const params =
        this.influencePageObj.sort === ""
          ? {
              magId: this.magId,
              page: page - 1,
              size
            }
          : {
              magId: this.magId,
              page: page - 1,
              size,
              sort: this.influencePageObj.sort
            };
      GetInfluence(params).then(res => {
        if (res && res.data && res.data.status === 0) {
          const { data } = res.data;
          const { content = [], totalElements = 0 } = data;
          this.influencePageObj = {
            ...this.influencePageObj,
            page,
            size,
            total: totalElements
          };
          this.influenceTableData = content;
        } else {
          const { message } = res.data;
          this.$message.error(message);
        }
      });
    },
    // 跳转论文详情页
    handleJumpUrl(chooseItem) {
      const { articleId = "" } = chooseItem;
      if (articleId && articleId !== "") {
        this.$router.push({
          path: "/articleDetails",
          query: { searchId: articleId }
        });
      }
    },
    // 获取引证和引用中间球的数据
    getCitationQuoteData() {
      const params = {
        id: this.chooseId
      };
      return GetAllCitationQuote(params).then(res => {
        if (res && res.data && res.data.status === 0) {
          const { data } = res.data;
          this.totalData = data;
          return true;
        } else {
          const { message } = res.data;
          this.$message.error(message);
          return false;
        }
      });
    },
    // 获取引证图谱中引用数据
    getQuoteGraphData() {
      let sortVal = "";
      if (this.chooseYearRange === 0) {
        sortVal = `${this.chooseYearVal},desc`;
      } else {
        sortVal = `totalCount${this.chooseYearRange},desc`;
      }
      const params = {
        magId: this.chooseId,
        page: 0,
        size: 10,
        sort: sortVal
      };
      return GetQuoteGraph(params).then(res => {
        if (res && res.data && res.data.status === 0) {
          const { data } = res.data;
          this.quoteList = data;
          this.quoteList.reverse();
          return true;
        } else {
          const { message } = res.data;
          this.$message.error(message);
          return false;
        }
      });
    },
    // 获取引证图谱中引证数据
    getCitationGraphData() {
      let sortVal = "";
      if (this.chooseYearRange === 0) {
        sortVal = `${this.chooseYearVal},desc`;
      } else {
        sortVal = `totalCount${this.chooseYearRange},desc`;
      }
      const params = {
        magId: this.chooseId,
        page: 0,
        size: 10,
        sort: sortVal
      };
      return GetCitationGraph(params).then(res => {
        if (res && res.data && res.data.status === 0) {
          const { data } = res.data;
          this.citationList = data;
          this.citationList.reverse();
          return true;
        } else {
          const { message } = res.data;
          this.$message.error(message);
          return false;
        }
      });
    },
    // 处理所有下载的函数
    handleDownload(downloadType = "") {
      if (downloadType === "influence") {
        window.open(
          `${exportInfluence}?magId=${this.magId}&page=${this.influencePageObj
            .page - 1}&size=${this.influencePageObj.size}&sort=${this
            .influencePageObj.sort || ""}`,
          "_self"
        );
        return;
      }
      if (downloadType === "citation") {
        window.open(
          `${exportCitation}?magId=${this.chooseId}&page=${this.citationPageObj
            .page - 1}&size=${this.citationPageObj.size}&sort=${this
            .citationPageObj.sort || ""}`,
          "_self"
        );
        return;
      }
      if (downloadType === "quote") {
        window.open(
          `${exportReference}?magId=${this.chooseId}&page=${this.quotePageObj
            .page - 1}&size=${this.quotePageObj.size}&sort=${this.quotePageObj
            .sort || ""}`,
          "_self"
        );
        return;
      }
      if (downloadType === "institution") {
        window.open(
          `${exportInstitution}?type=${this.institutionTypeValue}&magId=${
            this.magId
          }&page=${this.institutionPageObj.page - 1}&size=${
            this.institutionPageObj.size
          }&sort=${this.institutionPageObj.sort || ""}`,
          "_self"
        );
        return;
      }
      if (downloadType === "institutionCitation") {
        window.open(
          `${exportInstitutionCitation}?magId=${this.magId}`,
          "_self"
        );
        return;
      }
      if (downloadType === "article") {
        window.open(
          `${exportArticle}?type=${this.articleTypeValue}&magId=${
            this.magId
          }&page=${this.articlePageObj.page - 1}&size=${
            this.articlePageObj.size
          }&sort=${this.articleDetailPageObj.sort || ""}&type=${
            this.articleTypeValue
          }`,
          "_self"
        );
      }
    },
    // 排序的改变了
    handleChangeSort(prop, order, tableName) {
      if (tableName === "quote") {
        // 引用统计列表排序改变
        let sortValue = "";
        if (!order || order === "") {
          sortValue =
            this.quoteTimeValue === 3 ? "totalCount3,desc" : "totalCount5,desc";
        } else {
          if (order === "ascending") {
            sortValue = prop + ",asc";
          } else {
            sortValue = prop + ",desc";
          }
        }
        this.quotePageObj.sort = sortValue;
        this.getReferenceData();
      } else if (tableName === "citation") {
        // 引证统计列表排序改变
        let sortValue = "";
        if (!order || order === "") {
          sortValue =
            this.citationTimeValue === 3
              ? "totalCount3,desc"
              : "totalCount5,desc";
        } else {
          if (order === "ascending") {
            sortValue = prop + ",asc";
          } else {
            sortValue = prop + ",desc";
          }
        }
        this.citationPageObj.sort = sortValue;
        this.getCitationData();
      } else if (tableName === "institution") {
        // 机构发文统计排序改变
        let sortValue = "";
        if (!order || order === "") {
          sortValue =
            this.institutionTimeValue === 3
              ? "totalCount3,desc"
              : "totalCount5,desc";
        } else {
          if (order === "ascending") {
            sortValue = prop + ",asc";
          } else {
            sortValue = prop + ",desc";
          }
        }
        this.institutionPageObj.sort = sortValue;
        this.getInstitutionData();
      } else if (tableName === "article") {
        // 论文引证统计统计排序改变
        let sortValue = "";
        if (order && order !== "") {
          if (order === "ascending") {
            sortValue = prop + ",asc";
          } else {
            sortValue = prop + ",desc";
          }
        }
        this.articleDetailPageObj.sort = sortValue;  // 使用独立的排序对象
        this.getArticleData();
      } else if (tableName === "influence") {
        // 影响因子列表排序改变
        let sortValue = "";
        if (order && order !== "") {
          if (order === "ascending") {
            sortValue = prop + ",asc";
          } else {
            sortValue = prop + ",desc";
          }
        }
        this.influencePageObj.sort = sortValue;
        this.getInfluenceData();
      } else if (tableName === "citationInstitution") {
        // 论文引证统计统计排序改变
        let sortValue = "";
        if (order && order !== "") {
          if (order === "ascending") {
            sortValue = prop + ",asc";
          } else {
            sortValue = prop + ",desc";
          }
        }
        this.citationInstitutionPageObj.sort = sortValue;
        // this.getArticleData()
        this.citationInstitution();
      }
    },
    // 获取引证统计数据
    async getCitationData(pageParams = {}) {
      const { page = 1, size = 10 } = pageParams;
      const params = {
        magId: this.chooseId,
        page: page - 1,
        size,
        sort: this.citationPageObj.sort
      };
      GetCitationV2(params).then(res => {
        if (res && res.data && res.data.status === 0) {
          const { data } = res.data;
          const { content = [], totalElements = 0 } = data;
          this.citationPageObj = {
            ...this.citationPageObj,
            page,
            size,
            total: totalElements
          };
          this.citationTableData = content;
        } else {
          const { message } = res.data;
          this.$message.error(message);
        }
      });
    },
    // 获取引用统计数据
    async getReferenceData(pageParams = {}) {
      const { page = 1, size = 10 } = pageParams;
      const params = {
        magId: this.chooseId,
        page: page - 1,
        size,
        sort: this.quotePageObj.sort
      };
      GetReference(params).then(res => {
        if (res && res.data && res.data.status === 0) {
          const { data } = res.data;
          const { content = [], totalElements = 0 } = data;
          this.quotePageObj = {
            ...this.quotePageObj,
            page,
            size,
            total: totalElements
          };
          this.quoteTableData = content;
        } else {
          const { message } = res.data;
          this.$message.error(message);
        }
      });
    },
    // 跳转
    goRoute(val) {
      if (val.number) {
        console.log(val, "跳转");
      } else {
        this.$message.error("暂无数据");
        console.log(val, "不跳");
      }
    },
    // 期刊详情查询
    getMagDetail() {
      const params = {
        id: this.chooseId
      };
      GetMagDetail(params).then(res => {
        if (res && res.data && res.data.status === 0) {
          const { data } = res.data;
          let noKeys = ["cn"];
          for (let key in data) {
            if (!noKeys.includes(key)) {
              data[key] =
                data[key] === "" ||
                data[key] === null ||
                data[key] === undefined
                  ? "--"
                  : data[key];
            }
          }
          // this.includedDatabasesArr = data.includedDatabases ? JSON.parse(data.includedDatabases) : []
          this.$set(this, "detailObj", data);
        } else {
          const { message } = res.data;
          this.$message.error(message);
        }
      });
    },
    // 获取期刊统计概览信息
    getMagOverView(topYearParam) {
      // 无有效期刊 ID 时直接返回
      if (!this.chooseId) return;
      const topYear = this.normalizeTopYear(
        topYearParam !== undefined ? topYearParam : this.dictionaryTimeValue
      )
      const params = {
        id: this.chooseId,
        topYear
      };
      GetMagOverView(params).then(res => {
        if (res && res.data && res.data.status === 0) {
          const { data = {} } = res.data;
          const newArray = this.dictionary.map(item => {
            return {
              ...item,
              number: formatNum(data[item.key])
            };
          });
          this.$set(this, "dictionary", newArray);
        } else {
          const { message } = res.data;
          this.$message.error(message);
        }
      });
    },
    // 发文机构统计数据请求
    getInstitutionData(pageParams = {}) {
      const { page = 1, size = 10 } = pageParams;
      const params = {
        magId: this.chooseId,
        page: page - 1,
        size,
        type: this.institutionTypeValue,
        sort: this.institutionPageObj.sort
      };
      GetInstitution(params).then(res => {
        if (res && res.data && res.data.status === 0) {
          const { data } = res.data;
          const { content = [], totalElements = 0 } = data;
          const computedContent = content.map((row) => {
            const total5 = row.totalCount5 || 0
            const refered5 = row.referedCount5V2 || 0
            row.ratioCount5 = total5 === 0 ? '--' : Math.ceil(refered5 / total5)

            const total3 = row.totalCount3 || 0
            const refered3 = row.referedCount3V2 || 0
            row.ratioCount3 = total3 === 0 ? '--' : Math.ceil(refered3 / total3)

            return row
          })
          this.institutionPageObj = {
            ...this.institutionPageObj,
            page,
            size,
            total: totalElements
          };
          this.institutionTableData = computedContent;
        } else {
          const { message } = res.data;
          this.$message.error(message);
        }
      });
    },
    // 论文引证统计数据请求
    getArticleData(pageParams = {}) {
      const { page = 1, size = 10 } = pageParams;
      const params = {
        magId: this.chooseId,
        page: page - 1,
        size,
        type: this.articleTypeValue,
        ...(this.articleDetailPageObj.sort && { sort: this.articleDetailPageObj.sort }),  // 使用独立的排序对象
        top: this.articleDetailTimeValue === 3 ? 3 : 5
      };
      GetArticle(params).then(res => {
        if (res && res.data && res.data.status === 0) {
          const { data } = res.data;
          const { content = [], totalElements = 0 } = data;
          this.articlePageObj = {
            ...this.articlePageObj,
            page,
            size,
            total: totalElements
          };
          // 同时更新独立排序对象的分页信息
          this.articleDetailPageObj = {
            ...this.articleDetailPageObj,
            page,
            size,
            total: totalElements
          };
          this.articleTableData = content;
        } else {
          const { message } = res.data;
          this.$message.error(message);
        }
      });
    },
    // 引用图谱
    echart () {
      const chartDom = document.getElementById("mycharts");
      if (!chartDom) {
        // 图表容器不存在，可能是条件渲染未完成或功能已废弃
        console.warn('图表容器 #mycharts 不存在，跳过图表初始化');
        return;
      }
      let jnL; // 站位假数据
      let jnR; // 站位假数据
      let dxDataL; //左侧宽高
      let dxDataR; //右侧宽高
      let numsL; // 左侧个数
      let numsR; // 右侧个数
      let zbDataL = []; // 左侧坐标
      let zbDataR = []; // 右侧坐标
      if (this.quoteVal === "5") {
        // 5 个的宽高
        dxDataL = [180, 48]; // 宽 高
        numsL = 5;
        jnL = 5;
      } else {
        // 10 个的宽高
        dxDataL = [180, 24]; // 宽 高
        numsL = 10;
        jnL = 10;
      }
      if (this.citationVal === "5") {
        // 5 个的宽高
        dxDataR = [180, 48]; // 宽 高
        numsR = 5;
        jnR = 5;
      } else {
        // 10 个的宽高
        dxDataR = [180, 24]; // 宽 高
        numsR = 10;
        jnR = 10;
      }
      // 左 的坐标算法
      for (let i = 0; i < numsL; i++) {
        zbDataL.push([150, i * (560 / (numsL - 1))]);
      }
      // 右  的坐标算法
      for (let i = 0; i < numsR; i++) {
        zbDataR.push([850, i * (560 / (numsR - 1))]);
      }
      // 随机数
      let randomNumBoth = function(maxNum, minNum, decimalNum) {
        let max = 0;
        let min = 0;
        // eslint-disable-next-line no-unused-expressions
        minNum <= maxNum
          ? ((min = minNum), (max = maxNum))
          : ((min = maxNum), (max = minNum));
        switch (arguments.length) {
          case 1:
            return Math.floor(Math.random() * (max + 1));
          case 2:
            return Math.floor(Math.random() * (max - min + 1) + min);
          case 3:
            return (Math.random() * (max - min) + min).toFixed(decimalNum);
          default:
            return Math.random();
        }
      };
      let citationList = this.citationList.filter(item => {
        return (
          item[this.chooseDataKey] !== 0 && item[this.chooseDataKey] !== "0"
        );
      }); //右侧 引证
      let quoteList = this.quoteList.filter(item => {
        return (
          item[this.chooseDataKey] !== 0 && item[this.chooseDataKey] !== "0"
        );
      }); //左侧 引用
      citationList = citationList.slice(
        this.citationList.length - (this.citationVal - 0) >= 0
          ? this.citationList.length - (this.citationVal - 0)
          : 0,
        this.citationList.length
      );
      quoteList = quoteList.slice(
        this.quoteList.length - (this.quoteVal - 0) >= 0
          ? this.quoteList.length - (this.quoteVal - 0)
          : 0,
        this.quoteList.length
      );
      const citationGraphList = []; // 右侧引证数据
      const quoteGraphList = []; // 左侧引用数据
      const linkArray = []; // 线的数据
      //左侧
      for (let i = 0; i < quoteList.length; i += 1) {
        const quoteItem = {
          id: i + 1,
          searchName: quoteList[i].refMagName,
          name: quoteList[i].refMagName,
          x: quoteList[i][this.chooseDataKey], // 本刊引用
          y: [
            [
              quoteList[i].influence1 || 0,
              quoteList[i].influence2 || 0,
              quoteList[i].influence3 || 0
            ],
            randomNumBoth(1000, 2000)
          ], // 影响因子 + 发行量
          fixed: true,
          value: zbDataL[i], // 坐标
          symbolSize: quoteList[0].ctiMagName === "zwd99" ? "" : dxDataL,
          label: {
            fontSize: 14,
            color: "#666",
            formatter: function(value) {
              var res = value.name;
              if (res.length > 12) {
                res = res.substring(0, 11) + "..";
              }
              return res;
            }
          },
          category: 2,
          itemStyle: {
            normal: {
              borderType: "solid",
              borderColor: "#e7e7e7",
              borderWidth: 1,
              color: "#fff"
            }
          }
        };
        const tempVal = quoteList[i][this.chooseDataKey];
        const linkItem = {
          source: i + 1 + "",
          target: "0",
          label: {
            show: true,
            formatter: function(item) {
              return tempVal; // 数值
            },
            color: "#666",
            align: "center",
            verticalAlign: "middle"
          },
          lineStyle: {
            normal: {
              // color: "#12b5d0",
            }
          }
        };
        quoteGraphList.push(quoteItem);
        if (quoteList[0].ctiMagName === "zwd99") {
        } else {
          linkArray.push(linkItem);
        }
      }
      //右侧
      for (let i = 0; i < citationList.length; i += 1) {
        const citationItem = {
          id: i + 1 + quoteList.length,
          searchName: citationList[i].ctiMagName,
          name:
            citationList[i].ctiMagName === "zwd99"
              ? ""
              : citationList[i].ctiMagName,
          x: citationList[i][this.chooseDataKey], // 本刊引用
          y: [
            [
              citationList[i].influence1 || 0,
              citationList[i].influence2 || 0,
              citationList[i].influence3 || 0
            ],
            randomNumBoth(1000, 2000)
          ], // 影响因子 + 发行量
          fixed: true,
          value: zbDataR[i], // 坐标
          symbolSize: citationList[0].ctiMagName === "zwd99" ? "" : dxDataR,
          label: {
            fontSize: 14,
            color: "#666",
            formatter: function(value) {
              var res = value.name;
              if (res.length > 12) {
                res = res.substring(0, 11) + "..";
              }
              return res;
            }
          },
          category: 1,
          itemStyle: {
            normal: {
              borderType: "solid",
              borderColor: "#e7e7e7",
              borderWidth: 1,
              color: "#fff"
            }
          }
        };
        const tempVal = citationList[i][this.chooseDataKey];
        const linkItem = {
          source: "0",
          target: i + 1 + quoteList.length + "",
          label: {
            show: true,
            formatter: function(item) {
              return tempVal; // 数值
            },
            color: "#666",
            align: "center",
            verticalAlign: "middle"
          },
          lineStyle: {
            normal: {
              // color: "#12b5d0",
            }
          }
        };
        citationGraphList.push(citationItem);
        if (citationList[0].ctiMagName === "zwd99") {
        } else {
          linkArray.push(linkItem);
        }
      }
      let zdxData = [];
      // 左侧 动效 坐标数据
      for (let i = 0; i < quoteList.length; i++) {
        if (quoteList[0].refMagName === "zwd99") {
        } else {
          zdxData.push({
            coords: [zbDataL[i], [500, 280]]
          });
        }
      }
      let rdxData = [];
      // 右侧 动效 坐标数据
      for (let i = 0; i < citationList.length; i++) {
        if (citationList[0].ctiMagName === "zwd99") {
        } else {
          rdxData.push({
            coords: [[500, 280], zbDataR[i]]
          });
        }
      }
      const dxData = zdxData.concat(rdxData);
      //中间数据
      const data = [
        // 中间的
        {
          id: 0,
          name: this.totalData.name,
          tooltip: {
            formatter: function(item) {
              if (item && item.value) {
                let name = item.data.name || "";
                let data0 = item.data.y ? item.data.y[0][0] : "";
                let data1 = item.data.y ? item.data.y[0][1] : "";
                let data2 = item.data.y ? item.data.y[0][2] : "";
                let data3 = item.data.y ? item.data.y[0][3] : "";
                return `<ul style="text-align: left;font-size: 12px">
                        <li>${name}</li>
                        <li>影响因子：知网：${data0} 万方：${data1} 百度：${data2}</li>
                        <li>ISSN号：${data3}</li>
                      </ul>
               `;
              }
            }
          },
          symbolSize: [250, 250],
          value: [500, 280],
          x: 752,
          y: [
            [
              this.totalData.influence1 || 0,
              this.totalData.influence2 || 0,
              this.totalData.influence3 || 0,
              this.totalData.issn || ""
            ] || 0,
            randomNumBoth(1000, 2000)
          ], // 影响因子 + 发行量
          symbol: baseUrl,
          fixed: true,
          // draggable: false,
          category: 1,
          label: {
            fontSize: 20,
            color: "#fff"
          }
        },
        ...quoteGraphList,
        ...citationGraphList
      ];
      let that = this;
      // 暂时不展示的内容
      // <li>本刊引用：${item.data.x} 总被引:${item.data.x}</li>
      // <li>发文量：${item.data.y[1]}</li>
      // <li>ISSN号:1231321</li>
      let myChart = this.$echarts.init(document.getElementById("mycharts"));
      myChart.setOption(
        {
          backgroundColor: "#f5f7fd",
          xAxis: {
            show: false,
            type: "value"
          },
          yAxis: {
            show: false,
            type: "value"
          },
          tooltip: {
            formatter: function(item) {
              if (item && item.value) {
                let name = item.data.name || "";
                let data0 = item.data.y ? item.data.y[0][0] : "";
                let data1 = item.data.y ? item.data.y[0][1] : "";
                let data2 = item.data.y ? item.data.y[0][2] : "";
                return `<ul style="text-align: left;font-size: 12px">
                          <li>${name}</li>
                          <li>影响因子：知网：${data0} 万方：${data1} 百度：${data2}</li>
                        </ul>
                 `;
              }
            }
          },
          series: [
            {
              type: "graph",
              zlevel: 5,
              draggable: false,
              coordinateSystem: "cartesian2d", // 使用二维的直角坐标系（也称笛卡尔坐标系）
              symbol: "rect",
              // symbolOffset: ['15%', 0],
              label: {
                normal: {
                  show: true
                }
              },
              data: data,
              links: linkArray,
              lineStyle: {
                normal: {
                  opacity: 1,
                  color: "#53B5EA",
                  curveness: 0.2,
                  width: "2"
                }
              },
              itemStyle: {
                emphasis: {
                  shadowColor: "rgba(0, 0, 0, 0.2)",
                  shadowBlur: 10,
                  borderWidth: 0
                }
              }
            },
            {
              type: "lines",
              coordinateSystem: "cartesian2d",
              z: 1,
              zlevel: 2,
              animation: false,
              effect: {
                show: true,
                period: 5,
                trailLength: 0.01,
                symbolSize: 12,
                symbol: "pin",
                loop: true,
                color: "rgba(55,155,255,0.5)"
              },
              lineStyle: {
                normal: {
                  color: "#22AC38",
                  width: 0,
                  curveness: 0.2
                }
              },
              data: dxData
            }
          ]
        },
        true
      );
      if (myChart._$handlers.click) {
        myChart._$handlers.click.length = 0;
      }
      myChart.on("click", function(param) {
        // 关系图的节点被点击时此方法被回调。
        let { searchName = "" } = param.data;
        GetMagByName({ magName: searchName }).then(res => {
          if (res && res.data && res.data.status === 0) {
            const { data } = res.data;
            const { id = "" } = data;
            if (id !== "") {
              that.chooseId = id;
              //强制要求更新期刊概况信息
              that.dictionary.map(item => {
                that.$set(item, "number", "");
              });
              that.$router.push({ path: "/details", query: { searchId: id } }); // 跳转地址
            }
          } else {
            const { message = "" } = res.data;
            this.$message.error(message);
          }
        });
      });
    },
    getPastElevenYears() {
      const currentYear = new Date().getFullYear();
      const years = [];
      for (let i = 0; i < 11; i++) {
        years.push(currentYear - i);
      }
      this.pastElevenYears = years;
      this.selectedYear = currentYear;
    },
    // 获取默认表格行结构（无数据时显示）
    getDefaultTableRows() {
      const yearRange = this.currentYearRange;
      const rows = [];

      // 第一行：本刊文章见刊的年份
      const yearRow = { metricName: '本刊文章见刊的年份' };
      yearRange.forEach(year => {
        yearRow[`year_${year}`] = year;
      });
      rows.push(yearRow);

      // 第二行：在选定年份的被引次数
      const totalCitesRow = { metricName: `在${this.selectedYear}年的被引次数` };
      yearRange.forEach(year => {
        totalCitesRow[`year_${year}`] = '--';
      });
      rows.push(totalCitesRow);

      // 第三行：被本刊自己引用的次数
      const selfCitesRow = { metricName: '被本刊自己引用的次数' };
      yearRange.forEach(year => {
        selfCitesRow[`year_${year}`] = '--';
      });
      rows.push(selfCitesRow);

      return rows;
    },
    // 获取年度被引报告数据
    // @param {Number} year - 选中的年份，如果不传则使用 this.selectedYear
    // @param {Boolean} updateSelectedYear - 是否在请求成功后更新 selectedYear，默认为 false
    getCiteEveryYearData(year, updateSelectedYear = false) {
      if (!this.magId) {
        return;
      }

      // 如果传入了年份参数，则使用参数；否则使用当前选中的年份
      const targetYear = year !== undefined ? year : this.selectedYear;

      const params = {
        magId: this.magId,
        year: targetYear,
        size: 999 // 获取所有数据
      };

      GetciteEveryYear(params).then(res => {
        if (res && res.data && res.data.status === 0) {
          const { content = [] } = res.data.data;
          // 存储原始数据
          this.citeEveryYearTableData = content || [];
          // 如果需要在请求成功后更新 selectedYear，则更新（用于点击年份选择器时）
          if (updateSelectedYear && year !== undefined) {
            this.selectedYear = year;
            // 清除临时选中状态
            this.pendingSelectedYear = null;
          }
        } else {
          this.$message.error(res?.data?.message || '获取年度被引报告失败');
          this.citeEveryYearTableData = [];
          // 请求失败时也清除临时选中状态
          if (updateSelectedYear) {
            this.pendingSelectedYear = null;
          }
        }
      }).catch(err => {
        console.error('获取年度被引报告失败:', err);
        this.$message.error('获取年度被引报告失败');
        this.citeEveryYearTableData = [];
        // 请求失败时也清除临时选中状态
        if (updateSelectedYear) {
          this.pendingSelectedYear = null;
        }
      });
    },
    // 年份选择处理
    // @param {Number} year - 选中的年份
    handleYearSelect(year) {
      console.log("年份选择", year);
      // 先设置临时选中状态，用于高亮显示，但不更新 selectedYear（避免表格数据跳动）
      this.pendingSelectedYear = year;
      // 调用接口获取数据，等接口请求成功后再更新 selectedYear
      // 第二个参数设为 true，表示请求成功后更新 selectedYear
      this.getCiteEveryYearData(year, true);
    },
  }
};
</script>
<style scoped lang="scss">
/*.con_01 {*/
/*  width: 282px;*/
/*  height: 110px;*/
/*  background: #f5f7fd;*/
/*  margin-bottom: 5px;*/
/*}*/
.detailInfo {
  position: relative;
  padding-bottom: 20px;
  background: #fff;
  &_content {
    width: 1180px;
    margin: 0 auto;
    position: relative;
  }
  &_title {
    width: 600px;
    margin: 0px auto 100px;
    padding-top: 20px;
    /deep/ .el-divider__text {
      font-size: 30px;
      font-weight: bolder;
    }
    /deep/ .el-divider--horizontal {
      margin: 18px 0;
    }
  }
  .el-button--text {
    position: relative !important;
    font-size: 14px !important;
    color: #666666 !important;
    line-height: 16px !important;
    text-indent: 16px !important;
    top: -3px !important;
    margin-left: 30px !important;
  }
}
.SwitchingVersions {
  background: #169bd5;
  color: #fff;
  position: absolute;
  right: 5px;
  top: 5px;
}
.con_01 {
  height: 110px;
  flex: 1;
  background: #f5f7fd;
  margin-bottom: 5px;
  position: relative;
}
.conter_1 {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 15px 0 25px;
  gap: 10px;
}

.con_01_title {
  color: #666;
  font-size: 14px;
  margin-top: 10px;
}

.conter_3 {
  padding: 15px 0 25px;
}

.tj_year {
  color: #999;
  font-size: 14px;
  position: relative;
  top: -3px;
  right: -10px;
}
.postion {
  position: absolute;
  top: 40px;
  left: 30px;
  z-index: 100;
}
.postion1 {
  position: absolute;
  top: 40px;
  right: 30px;
  z-index: 100;
}
.tj_year1 {
  color: #999;
  font-size: 14px;
  position: relative;
  top: -3px;
  right: -10px;
}
.disDiv {
  display: flex;
}
.fengm {
  width: 166px;
  height: 240px;
  border: 1px solid #d4d4d4;
  margin-right: 30px;
}
.fengm img {
  float: left;
}
.detail {
  flex: 1;
  text-align: left;
}
.title_z {
  font-size: 20px;
  line-height: 30px;
  color: #333;
}
.title_e {
  font-size: 12px;
  line-height: 20px;
  color: #999;
}
.conter_4 {
  margin-top: 12px;
  display: flex;
}
.conter_4 ul li {
  line-height: 26px;
}
.conter_4 ul li p {
  display: inline-block;
  font-weight: bold;
  font-size: 14px;
  color: #666;
}
.conter_4 ul li span {
  font-size: 13px;
  color: #999;
}
.ul_1,
.ul_3 {
  width: 380px;
}
.ul_2 {
  width: 340px;
  margin: 0 20px;
}
.editLink {
  cursor: pointer;
  color: #169bd5;
}
::v-deep .btn .el-radio-button__inner {
  height: 30px !important;
  line-height: 30px !important;
}
.dictionary_box {
  display: flex;
  flex-direction: column;
}
.dictionary_radio {
  align-self: flex-end;
}
// 年度被引报告样式
.cite-every-year-selector {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 20px 0;
  background-color: #f1f2f4;
  flex-wrap: wrap;
  height: 40px;
  box-sizing: border-box;
  .cite-every-year-option {
    padding: 8px 16px;
    cursor: pointer;
    color: #606266;
    font-size: 14px;
    transition: all 0.3s;
    flex: 1;
    &:hover {
      color: #265cca;
      border-color: #265cca;
    }
    &.active {
      color: #265cca;
      border-color: #265cca;
      background-color: #ecf5ff;
      border-bottom: 2px solid #265cca;
    }
  }
}
.ceyt {
  margin-top: 20px;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  overflow: hidden;
  .ceyt-header {
    display: flex;
    background-color: #f5f7fa;
    border-bottom: 1px solid #e4e7ed;
  }
  .ceyt-row {
    display: flex;
    border-bottom: 1px solid #e4e7ed;
    &:last-child {
      border-bottom: none;
    }
    &:nth-child(even) {
      background-color: #fafafa;
    }
  }
  .ceyt-cell {
    padding: 12px 15px;
    text-align: center;
    border-right: 1px solid #e4e7ed;
    &:last-child {
      border-right: none;
    }
    &.ceyt-cell-header {
      background-color: #f5f7fa;
      font-weight: bold;
      color: #303133;
    }
    &.ceyt-cell-label {
      background-color: #f5f7fa;
      font-weight: 500;
      color: #303133;
      text-align: left;
      width: 140px;
      flex-shrink: 0;
    }
    &.ceyt-cell-data {
      color: #606266;
      flex: 1;
      // min-width: 80px;
    }
    &.ceyt-cell-year {
     font-weight: bold;
    }
  }
}
</style>
